var operatingSystemEnum = {
  IOS: 'iOS',
  WindowsPhone: 'WindowsPhone',
  Android: 'Android'
};

export { operatingSystemEnum as default };
//# sourceMappingURL=index.js.map
